export const CLEAR_PROGRAMS = 'programs/CLEAR_PROGRAMS';
export const GET_PROGRAMS = 'programs/GET_PROGRAMS';



// WEBPACK FOOTER //
// ./src/redux/Programs/constants.js